import { useTranslation } from 'react-i18next';
import styles from './ViewToggle.module.css';

// ---------------------------------------------------------------------------
// Card / list view toggle — Flutter _buildListLayoutChangeWidget (JobListView, SavedJobs)
// ---------------------------------------------------------------------------

export function ViewToggle({ isCardView, onToggle }: { isCardView: boolean; onToggle: () => void }) {
  const { t } = useTranslation();
  return (
    <div className={styles.viewToggle}>
      <button
        type="button"
        className={`${styles.viewToggleBtn} ${!isCardView ? styles.viewToggleBtnActive : ''}`}
        onClick={() => !isCardView || onToggle()}
        aria-pressed={!isCardView}
        aria-label={t('List view')}
        title={t('List view')}
      >
        <svg width="18" height="18" viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" aria-hidden="true">
          <path d="M7 5h10M7 10h10M7 15h10" />
          <circle cx="3.5" cy="5" r="0.8" fill="currentColor" />
          <circle cx="3.5" cy="10" r="0.8" fill="currentColor" />
          <circle cx="3.5" cy="15" r="0.8" fill="currentColor" />
        </svg>
      </button>
      <button
        type="button"
        className={`${styles.viewToggleBtn} ${isCardView ? styles.viewToggleBtnActive : ''}`}
        onClick={() => isCardView || onToggle()}
        aria-pressed={isCardView}
        aria-label={t('Card view')}
        title={t('Card view')}
      >
        <svg width="18" height="18" viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="1.6" aria-hidden="true">
          <rect x="3" y="3" width="6" height="6" rx="1.2" />
          <rect x="11" y="3" width="6" height="6" rx="1.2" />
          <rect x="3" y="11" width="6" height="6" rx="1.2" />
          <rect x="11" y="11" width="6" height="6" rx="1.2" />
        </svg>
      </button>
    </div>
  );
}
